import React from 'react'
import type { QuickAddTaskProviderProps } from './Context'
import { QuickAddTaskProvider } from './Context'
import { QuickAddTaskLayout } from './QuickAddTaskLayout'

export type QuickAddTaskProps = Omit<QuickAddTaskProviderProps, 'children'>

export const QuickAddTask = (props: QuickAddTaskProps) => {
  return (
    <QuickAddTaskProvider {...props}>
      <QuickAddTaskLayout />
    </QuickAddTaskProvider>
  )
}

export * from './Context'
export * from './useQuickAddTask'
